(function () {
	const SCROLL_LOCK_CLASS = "overflow-hidden-aside";

	const initAsideMenu = () => {
		const asideMenu = document.querySelector(".aside-menu");
		const openAsideMenuBtn = document.querySelector(
			".aside-menu__toggle--open-btn"
		);

		if (!asideMenu || !openAsideMenuBtn) return;
		if (asideMenu.dataset.asideMenuInit === "true") return;
		asideMenu.dataset.asideMenuInit = "true";

		const header = document.querySelector(".header-wrapper");
		const closeMenuBtn = document.querySelector(
			".aside-menu__toggle--full-close-btn"
		);
		const closeAsideMenuBtn = document.querySelector(
			".aside-menu__toggle--close-btn"
		);
		const asideMenuOverlay = document.querySelector(".aside-menu__overlay");

		// Must be document-wide: information-bar submenus live outside .aside-menu
		const firstLevelItems = document.querySelectorAll(".first_level_details");
		const secondLevelItems = document.querySelectorAll(".second_level_details");
		const firstLevelToggles = document.querySelectorAll(
			".aside-menu__toggle--close-btn"
		);

		if (header) header.preventHide = false;

		let savedScrollY = 0;

		const isMenuOpen = () =>
			asideMenu.classList.contains("aside-menu--open");

		const lockScroll = () => {
			if (document.body.classList.contains(SCROLL_LOCK_CLASS)) return;

			savedScrollY =
				window.pageYOffset ||
				document.documentElement.scrollTop ||
				document.body.scrollTop ||
				0;

			// Only toggle the overflow class. Do not set position/top on body —
			// leftover inline top/position is what leaves the page unscrollable
			// after close on mobile.
			document.body.classList.add(SCROLL_LOCK_CLASS);
		};

		const unlockScroll = () => {
			const wasLocked =
				document.body.classList.contains(SCROLL_LOCK_CLASS) ||
				document.body.style.top !== "" ||
				document.body.style.position === "fixed";

			document.body.classList.remove(SCROLL_LOCK_CLASS);
			document.documentElement.classList.remove(SCROLL_LOCK_CLASS);

			document.body.style.removeProperty("top");
			document.body.style.removeProperty("left");
			document.body.style.removeProperty("right");
			document.body.style.removeProperty("width");
			document.body.style.removeProperty("position");
			document.body.style.removeProperty("overflow");
			document.documentElement.style.removeProperty("overflow");

			if (!wasLocked) return;

			const y = savedScrollY;
			savedScrollY = 0;

			// Restore scroll only if a previous lock had pinned the page to top
			if (y > 0 && (window.pageYOffset || 0) < 1) {
				window.scrollTo(0, y);
				requestAnimationFrame(function () {
					window.scrollTo(0, y);
				});
			}
		};

		const resetSubmenus = () => {
			firstLevelItems.forEach((item) => {
				if (item.classList.contains("active")) {
					item.classList.remove("active");
					item.classList.add("hiding");
					setTimeout(() => item.classList.remove("hiding"), 800);
				}
			});

			secondLevelItems.forEach((item) => {
				if (item.classList.contains("active")) {
					item.classList.remove("active");
					item.classList.add("hiding");
					setTimeout(() => item.classList.remove("hiding"), 800);
				}
			});
		};

		const openAsideMenu = (e) => {
			e.preventDefault();
			if (isMenuOpen()) return;

			if (header) header.preventHide = true;
			asideMenu.classList.add("aside-menu--open");
			if (asideMenuOverlay) {
				asideMenuOverlay.classList.add("aside-menu__overlay--active");
			}
			lockScroll();
		};

		const closeAsideMenu = (e) => {
			if (
				e &&
				e.cancelable &&
				e.target &&
				typeof e.target.closest === "function" &&
				!e.target.closest("a[href]")
			) {
				e.preventDefault();
			}

			asideMenu.classList.remove("aside-menu--open");
			if (asideMenuOverlay) {
				asideMenuOverlay.classList.remove("aside-menu__overlay--active");
			}
			// Always clear lock styles — even if open class was already gone
			unlockScroll();
			resetSubmenus();

			if (header) header.preventHide = false;
		};

		firstLevelItems.forEach((item) => {
			const trigger = item.querySelector(".menu-trigger");
			if (!trigger || trigger.dataset.menuTriggerInit === "true") return;
			trigger.dataset.menuTriggerInit = "true";

			trigger.addEventListener("click", (e) => {
				// Let parent links (e.g. information-bar items) navigate normally
				if (e.target.closest(".menu-trigger > a[href]")) return;

				const isActive = item.classList.contains("active");

				firstLevelItems.forEach((other) => {
					if (other !== item && other.classList.contains("active")) {
						other.classList.remove("active");
						other.classList.add("hiding");
						setTimeout(() => other.classList.remove("hiding"), 800);
					}
				});

				secondLevelItems.forEach((sub) => {
					if (sub.classList.contains("active")) {
						sub.classList.remove("active");
						sub.classList.add("hiding");
						setTimeout(() => sub.classList.remove("hiding"), 800);
					}
				});

				if (!isActive) {
					item.classList.add("active");
				} else {
					item.classList.remove("active");
					item.classList.add("hiding");
					setTimeout(() => item.classList.remove("hiding"), 800);
				}
			});

			const subItems = item.querySelectorAll(".second_level_details");
			subItems.forEach((subItem) => {
				const subTrigger = subItem.querySelector(".menu-trigger");
				if (!subTrigger || subTrigger.dataset.menuTriggerInit === "true") return;
				subTrigger.dataset.menuTriggerInit = "true";

				subTrigger.addEventListener("click", (e) => {
					e.stopPropagation();

					const isSubActive = subItem.classList.contains("active");

					subItems.forEach((otherSub) => {
						if (
							otherSub !== subItem &&
							otherSub.classList.contains("active")
						) {
							otherSub.classList.remove("active");
							otherSub.classList.add("hiding");
							setTimeout(() => otherSub.classList.remove("hiding"), 800);
						}
					});

					if (!isSubActive) {
						subItem.classList.add("active");
						item.classList.add("active");
					} else {
						subItem.classList.remove("active");
						subItem.classList.add("hiding");
						setTimeout(() => subItem.classList.remove("hiding"), 800);
					}
				});
			});
		});

		firstLevelToggles.forEach((toggleButton) => {
			if (toggleButton.dataset.submenuBackInit === "true") return;
			toggleButton.dataset.submenuBackInit = "true";

			toggleButton.addEventListener("click", (event) => {
				event.stopPropagation();

				const parentItem = toggleButton.closest(
					".first_level_details, .second_level_details"
				);

				if (parentItem && parentItem.classList.contains("active")) {
					parentItem.classList.remove("active");
					parentItem.classList.add("hiding");
					setTimeout(() => parentItem.classList.remove("hiding"), 800);
				}

				secondLevelItems.forEach((sub) => {
					if (sub.classList.contains("active")) {
						sub.classList.remove("active");
						sub.classList.add("hiding");
						setTimeout(() => sub.classList.remove("hiding"), 800);
					}
				});
			});
		});

		openAsideMenuBtn.addEventListener("click", openAsideMenu);

		if (closeAsideMenuBtn) {
			closeAsideMenuBtn.addEventListener("click", closeAsideMenu);
		}

		if (asideMenuOverlay) {
			asideMenuOverlay.addEventListener("click", closeAsideMenu);
		}

		if (closeMenuBtn) {
			closeMenuBtn.addEventListener("click", closeAsideMenu);
		}

		asideMenu.addEventListener("keydown", (e) => {
			if (e.code === "Escape" && isMenuOpen()) {
				closeAsideMenu(e);
			}
		});

		// Recovery: if menu is closed but lock styles remain, clear them
		document.addEventListener(
			"touchstart",
			function () {
				if (!isMenuOpen()) unlockScroll();
			},
			{ passive: true }
		);
	};

	document.addEventListener("shopify:section:load", initAsideMenu);
	document.addEventListener("shopify:section:unload", initAsideMenu);
	document.addEventListener("shopify:section:reorder", initAsideMenu);

	initAsideMenu();
})();
